module.exports = __webpack_public_path__ + "static/media/article-c.eb68d074.jpg";